module.exports = __webpack_public_path__ + "./Ian_6e8792f9d671ceaeed76bfe2fa7e7985.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/static/images/sectionTalking/2019/Ian.jpg
// module id = 478
// module chunks = 0